// extracted by mini-css-extract-plugin
module.exports = {"editBtn":"AdminSettingsRequestDetailsContainer_editBtn__3DiBz","detail":"AdminSettingsRequestDetailsContainer_detail__3p80L"};